export default "__VITE_ASSET__CfWIv9z2__"